// extracted by mini-css-extract-plugin
export default {"secondary-sm":"LoadingPage-rebranding-module__secondary-sm___27krL","wrapperLoadingAnimation":"LoadingPage-rebranding-module__wrapperLoadingAnimation___22qvH"};